import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../auth/services/auth.service";
import { environment } from "../../../environments/environment";
import { skipAuth, useSessionToken } from "../auth-context";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

  const authService = inject(AuthService);

  if (req.context.get(skipAuth)) {
    return next(req);
  }

  if (req.context.get(useSessionToken)) {

    const newReq = req.clone({
      headers: req.headers.set('sessionToken', `${authService.sessionToken()}`)
    });

    return next(newReq);
  }

  let tokenName = 'token';
  let token = authService.sessionToken();

  if (req.url.startsWith(environment.apiUrl)) {
    tokenName = 'AuthorizationToken';
    token = authService.authToken();
  }

  const newReq = req.clone({
    headers: req.headers.set(`${tokenName}`, `${token}`)
  });

  return next(newReq);
}